import React from 'react';
import PropTypes from 'prop-types';

import Input from '../../UI/Input';
import VariablesWrapper from './VariablesWrapper';

const VariablesCopy = ({ data, title, mainHeadTitle, mainText, documentValues, onValuesChange }) => {
  const renderTextWithInputFields = (text) => {
    let source = text
    let fieldRegex = /\{d\.([^}]*)\}/g
    let fields = text.match(fieldRegex)
    let items = []
    for(let i in fields) {
      let components = source.split(fields[i])
      items.push(components[0])
      items.push(fields[i])
      source = components[1]
    }
    if(source) {
      items.push(source)
    }
    return (
      <div className="variables__text">
        { items.map((item, i) => {
            if(item.match(fieldRegex)) {
              // input field
              return <Input value={documentValues[fieldKeyFromHandle(item) || '']} key={`input_${item}_${i}`} editMode onChange={(e) => onValueChange(fieldKeyFromHandle(item), e.target.value)} />
            } else {
              return item
            }
          })
        }
      </div>
    )
  }

  const fieldKeyFromHandle = (handle) => {
    return handle.substring(3, handle.length - 1)
  }

  const onValueChange = (handle, value, choicesName = null) => {
    let dv = documentValues
    dv[handle] = value
    onValuesChange(dv, handle, value, data.id, choicesName)
  }

  return(
    <section id={data.id} className="wrap-section">
      <h4><span>{title}</span></h4>
      {data['sections'].map((section, index) => (
        <VariablesWrapper 
          key={index} 
          title={section.heading} 
          data={section.sections} 
          onValueChange={onValueChange} 
          documentValues={documentValues}
          renderTextWithInputFields={renderTextWithInputFields}
        />
    ))}
    </section>
  );
}

VariablesCopy.propTypes = {
  
}

export default VariablesCopy;